export const path = "/master-roundler";
export const component = () => import("./index.jsx");
export const sidebar = {
  title: "MASTER ROUNDLER",
  section: "ROUNDLER",
  group: null,
  order: 1,
  roles: [
    "Authenticated",
    "roundler-admin",
    "design",
    "design-roundler",
    "master-rrss-roundler",
    "aluna",
  ],
};
